import { useAuth } from "react-oidc-context";

export default function useAccess(): string[] {
	const auth = useAuth();

	const profile = auth.user?.profile;
	// @ts-ignore
	const strombestilling = profile?.resource_access?.["strombestilling"]?.roles || [];
	// @ts-ignore
	const portal = profile?.resource_access?.["mittnte-adminapi"]?.roles || [];
	return [...strombestilling, ...portal];
}
